import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR,
  RESET_ACTION_STATUS
} from '@/store/helpers';

import { 
  GET_RTT_DASH_LOG,
  GET_RTT_ERRORS_LAST_CALLS,
  GET_RTT_REFERENCES
} from './actionTypes';

import {
  SET_RTT_REFERENCES
} from './mutationTypes';

import { 
  pingTreeTargetService,
  ringTreeTargetDashboardService,
  httpRequestService,
  $ngStateService 
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

const actions = {
  async [GET_RTT_DASH_LOG]({ rootState, commit }, dates) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTT_DASH_LOG });
    try {
      const response = await ringTreeTargetDashboardService.getRttDashboardLogs(rootState.currentAccountId, dates)
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_RTT_DASH_LOG });
      return response;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_RTT_DASH_LOG, error: e });
    }
  },

  async [GET_RTT_ERRORS_LAST_CALLS]({ rootState, commit }, cellProps) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTT_ERRORS_LAST_CALLS });
    try {
      const response = await ringTreeTargetDashboardService.getRttLastErrors(rootState.currentAccountId, cellProps)
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_RTT_ERRORS_LAST_CALLS });
      return response;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_RTT_ERRORS_LAST_CALLS, error: e });
    }
  },

  async [GET_RTT_REFERENCES]({ rootState, commit }, ringTreeTargetId) {
    commit(SET_RTT_REFERENCES, []);
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTT_REFERENCES });
    try {
      const response = await pingTreeTargetService.getTargetReferences(rootState.currentAccountId, ringTreeTargetId);
      // Unify logic
      const references = [];
      if (response.data.pingtrees) {
        references.push(...response.data.pingtrees.map(pingtree => {
          return {
            type: 'Ring Tree',
            name: pingtree.pingtreeName,
            id: pingtree.pingtreeId,
            link: $ngStateService.href('dashboard.ringtree.edit', { pingTreeId: pingtree.pingtreeId }, { absolute: true })
          };
        }));
      }
      if (response.data.campaigns) {
        references.push(...response.data.campaigns.map(campaign => {
          return {
            type: 'Campaign Routing',
            name: campaign.campaignName,
            id: campaign.campaignId,
            link: $ngStateService.href('dashboard.campaign', { campaignId: campaign.campaignId }, { absolute: true })
          };
        }));
      }

      if (response.data.callplans) {
        references.push(...response.data.callplans.map(callplan => {
          return {
            type: 'Call Flow Routing Plan',
            name: callplan.callplanName,
            id: callplan.callplanId,
            link: $ngStateService.href('dashboard.call-plans.edit', { callPlanId: callplan.callplanId }, {absolute: true})
          };
        }));
      }

      commit(SET_RTT_REFERENCES, references);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_RTT_REFERENCES });
    } catch (e) {
      commit(SET_RTT_REFERENCES, []);
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_RTT_REFERENCES, error: e });
    }

  },

  async resetRequestSettingsRequest({ commit }) { 
    commit(RESET_ACTION_STATUS, { actionName: 'requestSettingsRequest' });
  },

  async resetConfirmationSettingsRequest({ commit }) { 
    commit(RESET_ACTION_STATUS, { actionName: 'confirmationSettingsRequest' });
  },

  async requestSettingsRequest({ rootState, commit }, payload) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'requestSettingsRequest' });
    try {
      const response = await httpRequestService.httpRequest(rootState.currentAccountId, payload);
      if (response.data.responseCode && response.data.responseCode >= 200 && response.data.responseCode < 300) {
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'requestSettingsRequest' });
      } else if (response.data.responseCode && response.data.responseCode >= 300) {
        commit(SET_ACTION_STATUS_ERROR, { actionName: 'requestSettingsRequest', error: response.data.body });
      }
      return response.data;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'requestSettingsRequest', error: e.data.message  });
    }
  },

  async confirmationSettingsRequest({ rootState, commit }, payload) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'confirmationSettingsRequest' });
    try {
      const response = await httpRequestService.httpRequest(rootState.currentAccountId, payload);
      if (response.data.responseCode && response.data.responseCode >= 200 && response.data.responseCode < 300) {
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'confirmationSettingsRequest' });
      } else if (response.data.responseCode && response.data.responseCode >= 300) {
        commit(SET_ACTION_STATUS_ERROR, { actionName: 'confirmationSettingsRequest', error: response.data.body });
      }
      return response.data;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'confirmationSettingsRequest', error: e.data.message  });
    }
  }
};
export default actions;
